import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ndr-summary',
  templateUrl: './ndr-summary.component.html',
  styleUrls: ['./ndr-summary.component.scss'],
})
export class NDRSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
